import Breadcrumbs from "./Breadcrumbs";
import type { BreadcrumbItem } from "@/lib/breadcrumbs-base";

export default function AutoBreadcrumbsFrame({ trail }: { trail: BreadcrumbItem[] }) {
  return (
    // Breadcrumbs renders the one <nav aria-label="Breadcrumb"> landmark; a
    // second navigation role here made screen readers announce two.
    <div className="mx-auto max-w-6xl px-4 pt-4 pb-1">
      <Breadcrumbs trail={trail} />
    </div>
  );
}
